import { render, staticRenderFns } from "./TaskQueueForm.vue?vue&type=template&id=90051510&"
import script from "./TaskQueueForm.vue?vue&type=script&lang=js&"
export * from "./TaskQueueForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports